module.exports = __webpack_public_path__ + "assets/img/yl_w_d_i_23.d0fe2400.jpg";